import axios from 'axios';

export const API_URL = {
  COMMON: {
    GET_IMAGE: '/get_image',
    GET_MOON_INFO: '/get_moon_info',
    GET_SERVER_TIME: '/get_server_time',
  },
  NOW: {
    GET_ALL_OBS_DATA: '/now/get_all_obs_data',
  },
  SKYW: {
    GET_SERVER_TIME: '/skyw/get_server_time',
    GET_LATEST_SKYCAM: '/skyw/get_latest_skycam',
    GET_WEATHER_DATA: '/skyw/get_weather_data',
    GET_SKYCAM_IMAGE: '/skyw/get_skycam_image',
  },
  FORECAST: {
    GET_OBS_DATETIME: "/forecast/get_obs_datetime",
    GET_OBS_INFO: "/forecast/get_forecast_info",
    GET_DEV_INFO: "/forecast/get_forecast_dev_info",
    GET_DEV_DELAY: "/forecast/get_forecast_dev_delay",
    UPDATE_DEV_DELAY: "/forecast/update_forecast_dev_delay"
  },
  DISPLAY: {
    FETCH_IMAGES: "/display/fetch_images"
  }
};

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export default API;
